import { Dropdown, Icon, Input } from 'Components';
import Carousel from 'LearningManager/components/Carousel';
import CourseCard from 'LearningManager/components/CourseCard';
import CourseDetailModal from 'LearningManager/components/CourseDetailModal';
import Heading from 'LearningManager/components/Heading';
import {
	IndividualCoursesData,
	courseDetailMockData
} from 'LearningManager/constants/createAssignment.constant';
import styles from 'LearningManager/styles/CustomSetup.module.scss';
import { Menu } from 'antd';
import { useState } from 'react';
import { useStepper } from 'LearningManager/hooks/Stepper.context';

const SelectCourses: React.FC = () => {
	const [showDetails, setShowDetails] = useState(false);
	return (
		<div className={styles.root}>
			<Heading
				title="Select Courses"
				subHeading="Select courses or learning paths to edit"
			/>
			<Filters />
			<LearningPath openDetails={() => setShowDetails(true)} />
			<IndividualCourses openDetails={() => setShowDetails(true)} />
			<CourseDetailModal
				visible={showDetails}
				onClose={() => setShowDetails(false)}
				{...courseDetailMockData}
			/>
		</div>
	);
};

const Filters = () => {
	const menu = (
		<Menu style={{ borderRadius: '6px' }}>
			<Menu.Item>English</Menu.Item>
			<Menu.Item disabled>Spanish</Menu.Item>
			<Menu.Item disabled>French</Menu.Item>
			<Menu.Item disabled>German</Menu.Item>
		</Menu>
	);

	return (
		<div className={styles.filter}>
			<Input.Search
				className={styles.input}
				placeholder="Search"
				suffix={<Icon type="search" role="img" />}
			/>
			<div className={styles.select}>
				<Dropdown overlay={menu} className={styles.dropdown}>
					English
				</Dropdown>
			</div>
		</div>
	);
};

const LearningPath = ({ openDetails }: { openDetails: () => void }) => {
	const {
		draft: {
			customSetup: { selectedLearningPathCourseIds }
		},
		toggleCustomCourseSelection
	} = useStepper();
	const courses = [...IndividualCoursesData[0].courses];

	const toggleSelect = (id: number) => {
		toggleCustomCourseSelection('selectedLearningPathCourseIds', id);
	};

	return (
		<div className={styles.learningWrapper}>
			<Heading
				icon={
					<Icon className={styles.icon} type="pathIcon" role="img" />
				}
				title="Learning Paths"
				subHeading="A structured series of courses for effective cybersecurity learning"
			/>
			<Carousel
				data={courses}
				label="Data Privacy Training"
				itemsPerPage={4}
				renderItem={(course) => (
					<CourseCard
						index={course.id}
						course={{
							...course,
							isSelected: selectedLearningPathCourseIds.includes(
								course.id
							)
						}}
						onClick={openDetails}
						onSelect={toggleSelect}
					/>
				)}
			/>
		</div>
	);
};

const IndividualCourses = ({ openDetails }: { openDetails: () => void }) => {
	const {
		draft: {
			customSetup: { selectedIndividualCourseIds }
		},
		toggleCustomCourseSelection
	} = useStepper();
	const courses = [...IndividualCoursesData[0].courses];

	const toggleSelect = (id: number) => {
		toggleCustomCourseSelection('selectedIndividualCourseIds', id);
	};

	return (
		<div className={styles.learningWrapper}>
			<Heading
				icon={
					<Icon
						className={styles.icon}
						type="coursesIcon"
						role="img"
					/>
				}
				title="Individual Courses"
			/>
			<div className={styles.individualWrapper}>
				<Carousel
					data={courses}
					label="Data Privacy Training"
					itemsPerPage={4}
					renderItem={(course) => (
						<CourseCard
							index={course.id}
							course={{
								...course,
								isSelected: selectedIndividualCourseIds.includes(
									course.id
								)
							}}
							onClick={openDetails}
							onSelect={toggleSelect}
						/>
					)}
				/>
				<Carousel
					data={courses}
					label="Data Privacy Training"
					itemsPerPage={4}
					renderItem={(course) => (
						<CourseCard
							index={course.id}
							course={{
								...course,
								isSelected: selectedIndividualCourseIds.includes(
									course.id
								)
							}}
							onClick={openDetails}
							onSelect={toggleSelect}
						/>
					)}
				/>
				<Carousel
					data={courses}
					label="Privacy Training"
					itemsPerPage={4}
					renderItem={(course) => (
						<CourseCard
							index={course.id}
							course={{
								...course,
								isSelected: selectedIndividualCourseIds.includes(
									course.id
								)
							}}
							onClick={openDetails}
							onSelect={toggleSelect}
						/>
					)}
				/>
				<Carousel
					data={courses.slice(0, 2)}
					label="Human Resources"
					itemsPerPage={4}
					renderItem={(course) => (
						<CourseCard
							index={course.id}
							course={{
								...course,
								isSelected: selectedIndividualCourseIds.includes(
									course.id
								)
							}}
							onClick={openDetails}
							onSelect={toggleSelect}
						/>
					)}
				/>
				<Carousel
					data={courses}
					label="Other Topics"
					itemsPerPage={4}
					renderItem={(course) => (
						<CourseCard
							index={course.id}
							course={{
								...course,
								isSelected: selectedIndividualCourseIds.includes(
									course.id
								)
							}}
							onClick={openDetails}
							onSelect={toggleSelect}
						/>
					)}
				/>
			</div>
		</div>
	);
};

export default SelectCourses;
